import { Component, ReactNode } from "react";
import { Alert, Button, Container } from "@mui/material";

export default class SellingErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed)
      return (
        <Container sx={{ py: 4 }}>
          <Alert
            severity="error"
            action={
              <Button color="inherit" onClick={() => window.location.reload()}>
                Reload
              </Button>
            }
          >
            We couldn't display the selling form. Reload to resume any saved
            text draft. Unsaved entries may not be recoverable; photos must be
            reselected.
          </Alert>
        </Container>
      );
    return this.props.children;
  }
}
